import { useState, useEffect } from "react";
import { C, TM, TRADES } from "../lib/constants";
import { isPremiumWorker, mergeWorkersStable } from "../lib/helpers";
import { FICIO_DIRECTORY_CACHE } from "../lib/cache";
import { Stars } from "./ui/Stars";
import { Btn } from "./ui/Btn";
import { Av } from "./ui/Av";
import { Chip } from "./ui/Chip";
import { LoginRequiredBox } from "./ui/LoginRequiredBox";

// ─── DIRECTORY ────────────────────────────────────────────────────────────────
// Estado → Ciudades disponibles (por ahora solo Sinaloa / Los Mochis activo)
const GEO = {
  "Todos los estados": [],
  "Aguascalientes": ["Aguascalientes","Jesús María","Calvillo","Rincón de Romos","San Francisco de los Romo"],
  "Baja California": ["Tijuana","Mexicali","Ensenada","Rosarito","Tecate","San Felipe"],
  "Baja California Sur": ["La Paz","Los Cabos","Comondú","Loreto","Mulegé"],
  "Campeche": ["Campeche","Ciudad del Carmen","Champotón","Calkiní","Escárcega"],
  "Chiapas": ["Tuxtla Gutiérrez","San Cristóbal de las Casas","Tapachula","Comitán","Palenque","Ocosingo"],
  "Chihuahua": ["Chihuahua","Ciudad Juárez","Delicias","Cuauhtémoc","Parral","Ojinaga","Nuevo Casas Grandes"],
  "Ciudad de México": ["Álvaro Obregón","Azcapotzalco","Benito Juárez","Coyoacán","Cuajimalpa","Cuauhtémoc","Gustavo A. Madero","Iztacalco","Iztapalapa","La Magdalena Contreras","Miguel Hidalgo","Milpa Alta","Tláhuac","Tlalpan","Venustiano Carranza","Xochimilco"],
  "Coahuila": ["Saltillo","Torreón","Monclova","Piedras Negras","Acuña","Sabinas","San Pedro"],
  "Colima": ["Colima","Manzanillo","Tecomán","Villa de Álvarez","Armería"],
  "Durango": ["Durango","Gómez Palacio","Lerdo","Santiago Papasquiaro","El Salto"],
  "Guanajuato": ["León","Guanajuato","Irapuato","Celaya","Salamanca","Silao","San Miguel de Allende","Moroleón"],
  "Guerrero": ["Chilpancingo","Acapulco","Zihuatanejo","Taxco","Iguala","Chilapa"],
  "Hidalgo": ["Pachuca","Tulancingo","Tula","Huejutla","Actopan","Tizayuca"],
  "Jalisco": ["Guadalajara","Zapopan","Tlaquepaque","Tonalá","Puerto Vallarta","Lagos de Moreno","Tepatitlán"],
  "Estado de México": ["Toluca","Ecatepec","Naucalpan","Tlalnepantla","Nezahualcóyotl","Chimalhuacán","Texcoco","Metepec","Atizapán","Coacalco"],
  "Michoacán": ["Morelia","Uruapan","Zamora","Apatzingán","Lázaro Cárdenas","Zitácuaro"],
  "Morelos": ["Cuernavaca","Jiutepec","Cuautla","Temixco","Yautepec"],
  "Nayarit": ["Tepic","Bahía de Banderas","Santiago Ixcuintla","Tuxpan","Compostela"],
  "Nuevo León": ["Monterrey","Guadalupe","San Nicolás","Apodaca","Escobedo","Santa Catarina","San Pedro Garza García"],
  "Oaxaca": ["Oaxaca de Juárez","Salina Cruz","Tuxtepec","Juchitán","Huajuapan","Puerto Escondido"],
  "Puebla": ["Puebla","Tehuacán","San Martín Texmelucan","Atlixco","Cholula","Izúcar de Matamoros"],
  "Querétaro": ["Querétaro","San Juan del Río","El Marqués","Corregidora","Tequisquiapan"],
  "Quintana Roo": ["Cancún","Playa del Carmen","Cozumel","Chetumal","Tulum","Felipe Carrillo Puerto"],
  "San Luis Potosí": ["San Luis Potosí","Soledad","Matehuala","Ciudad Valles","Rioverde","Tamazunchale"],
  "Sinaloa": ["Los Mochis","Culiacán","Mazatlán","Guasave","Guamúchil","Navolato","Salvador Alvarado","Escuinapa","El Fuerte","Mocorito"],
  "Sonora": ["Hermosillo","Ciudad Obregón","Nogales","Guaymas","San Luis Río Colorado","Navojoa","Caborca"],
  "Tabasco": ["Villahermosa","Cárdenas","Macuspana","Comalcalco","Huimanguillo"],
  "Tamaulipas": ["Tampico","Reynosa","Matamoros","Nuevo Laredo","Victoria","Madero","Altamira"],
  "Tlaxcala": ["Tlaxcala","Apizaco","Huamantla","Chiautempan","Zacatelco"],
  "Veracruz": ["Veracruz","Xalapa","Coatzacoalcos","Córdoba","Minatitlán","Orizaba","Poza Rica","Tuxpan"],
  "Yucatán": ["Mérida","Valladolid","Progreso","Tizimín","Umán","Kanasín"],
  "Zacatecas": ["Zacatecas","Guadalupe","Fresnillo","Jerez","Loreto","Sombrerete"],
};


export const Directory = ({setScreen, setSelected, user, directoryData, directoryLoading, refreshDirectory, hasTrabajador}) => {
  const [tab,    setTab]    = useState("workers");
  const [search, setSearch] = useState("");
  const [trade,  setTrade]  = useState("Todos");
  const [estado, setEstado] = useState("Sinaloa");
  const [ciudad, setCiudad] = useState("Los Mochis");
  const [avail,  setAvail]  = useState(false);
  const [sort,   setSort]   = useState("rating");

  // PASO 38: Directory ya NO mantiene estado local del directorio.
  // Lee directamente de directoryData que vive en App.js (cerebro global).
  // Esto elimina parpadeos y el directorio vacío al regresar de otras pantallas.
  const workersDB     = directoryData?.workers     || FICIO_DIRECTORY_CACHE.workers     || [];
  const supervisorsDB = directoryData?.supervisors || FICIO_DIRECTORY_CACHE.supervisors || [];

  const loadingDB     = Boolean(directoryLoading) && workersDB.length === 0;

  useEffect(() => {
    // Directory solo dispara un refresh ligero al montar — sin crear suscripciones propias
    // porque App.js ya tiene el canal global activo.
    if (typeof refreshDirectory === "function") {
      refreshDirectory({ force: false });
    }
  }, [refreshDirectory]);


  if (!user) return <LoginRequiredBox setScreen={setScreen} title="Inicia sesión para buscar maestros" desc="Para usar el buscador, abrir perfiles completos, solicitar cotización o contactar por WhatsApp necesitas una cuenta de cliente."/>;

  const ciudades = GEO[estado] || [];

  // ── Algoritmo de meritocracia ──────────────────────────────────────────────
  // Score = 60% calificación + 25% actividad reciente + 15% plan
  const planBoost = {premium:1, basico:0};
  const score = (w) => {
    const cal  = (w.rating / 5) * 60;
    const act  = Math.min(w.jobs / 120, 1) * 25;
    const plan = (planBoost[String(w.plan || "").toLowerCase()] || 0) * 15;
    return cal + act + plan;
  };

  // FIX: sourceWorkers solo de directoryData (estado central en App.js).
  // No mezclar con WORKERS[] estático (vacío) ni con cache directo — evita duplicados.
  const sourceWorkers = workersDB.length > 0
    ? workersDB
    : mergeWorkersStable(FICIO_DIRECTORY_CACHE.workers);

  const base = sourceWorkers.filter(w => {
    const q = search.toLowerCase();
    return ((w.name || "").toLowerCase().includes(q)||(w.trade || "").toLowerCase().includes(q)||(w.specialty || "").toLowerCase().includes(q))
      &&(trade==="Todos"||w.trade===trade)
      &&(estado==="Todos los estados"?true:(!ciudad || String(w.zone || "").toLowerCase().includes(String(ciudad).toLowerCase())))
      &&(!avail||w.available)
      && String(w.membresia || "activa").toLowerCase() !== "inactiva";
  });

  // Premiun fijos — max 2 por oficio
  const premiumPool = base.filter(w=>isPremiumWorker(w));
  const premiumTop  = premiumPool.sort((a,b)=>score(b)-score(a)).slice(0,2);
  const premiumIds  = new Set(premiumTop.map(w=>w.id));

  // Meritocracia — el resto ordenado por score
  const merito = base
    .filter(w=>!premiumIds.has(w.id) && !w.nuevo)
    .sort((a,b)=> sort==="rating" ? score(b)-score(a) : b.jobs-a.jobs);

  // Nuevos — solo si hay búsqueda activa
  const nuevos = base.filter(w=>w.nuevo && !premiumIds.has(w.id));
  const hayBusqueda = search.trim().length>0 || trade!=="Todos";

  const filtered = [...premiumTop, ...merito];

  const tb = (key,label,icon) => (
    <button onClick={()=>setTab(key)} style={{flex:1,border:"none",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",borderRadius:10,padding:"10px 4px",background:tab===key?C.accent:"transparent",color:tab===key?"#fff":C.muted}}>{icon} {label}</button>
  );

  return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}>
      <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:"0 20px",position:"sticky",top:0,zIndex:50,boxShadow:"0 1px 8px rgba(0,0,0,0.06)"}}>
        <div style={{maxWidth:640,margin:"0 auto",padding:"16px 0"}}>
          <div style={{fontFamily:"'Georgia',serif",fontSize:22,fontWeight:800,color:C.text,marginBottom:12}}>
            FI<span style={{color:C.accent}}>CI</span>O
          </div>
          <div style={{display:"flex",gap:4,background:C.faint,borderRadius:12,padding:4}}>
            {tb("workers","Trabajadores","🔨")}{tb("supervisors","Supervisores","🏗️")}
          </div>
        </div>
      </div>

      <div style={{maxWidth:640,margin:"0 auto",padding:"20px 20px 0"}}>
        {tab==="workers" && (
          <>
            <div style={{position:"relative",marginBottom:12}}>
              <span style={{position:"absolute",left:14,top:"50%",transform:"translateY(-50%)",fontSize:16}}>🔍</span>
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Busca oficio, nombre o especialidad..."
                style={{width:"100%",background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:14,padding:"13px 14px 13px 44px",color:C.text,fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}
                onFocus={e=>e.target.style.borderColor=C.accent} onBlur={e=>e.target.style.borderColor=C.border}/>
            </div>

            <div style={{overflowX:"auto",marginBottom:12,paddingBottom:4,scrollbarWidth:"none"}}>
              <div style={{display:"flex",gap:8,width:"max-content"}}>
                {TRADES.map(t=>{
                  const m=TM[t]; const on=trade===t;
                  return <button key={t} onClick={()=>setTrade(t)} style={{display:"flex",alignItems:"center",gap:5,background:on?m.color:C.surface,border:`1.5px solid ${on?m.color:C.border}`,borderRadius:20,padding:"7px 14px",color:on?"#fff":C.sub,fontSize:12,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap",flexShrink:0,fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",transition:"all 0.15s",boxShadow:on?`0 2px 8px ${m.color}40`:"none"}}><span>{m.icon}</span>{t}</button>;
                })}
              </div>
            </div>

            {/* Filtro Estado → Ciudad */}
            <div style={{background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:14,padding:"12px 14px",marginBottom:12,boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
              <div style={{color:C.sub,fontSize:10,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>📍 Ubicación</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {/* Estado */}
                <div style={{flex:1,minWidth:140}}>
                  <div style={{color:C.muted,fontSize:10,marginBottom:4,fontWeight:600}}>Estado</div>
                  <select value={estado} onChange={e=>{setEstado(e.target.value);setCiudad("");}}
                    style={{width:"100%",background:C.bg,border:`1.5px solid ${estado!=="Todos los estados"?C.accent:C.border}`,borderRadius:10,color:C.text,padding:"9px 10px",fontSize:13,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",fontWeight:600}}>
                    {Object.keys(GEO).map(e=><option key={e} value={e}>{e}</option>)}
                  </select>
                </div>
                {/* Ciudad */}
                {estado !== "Todos los estados" && (
                  <div style={{flex:1,minWidth:140}}>
                    <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:4}}>
                      <div style={{color:C.muted,fontSize:10,fontWeight:600}}>Ciudad</div>
                      {ciudad === "Los Mochis" && <span style={{background:C.accentL,color:C.accent,fontSize:9,fontWeight:700,padding:"1px 6px",borderRadius:6}}>ACTIVO</span>}
                      {ciudad && ciudad !== "Los Mochis" && <span style={{background:"#FFF3E0",color:"#E65100",fontSize:9,fontWeight:700,padding:"1px 6px",borderRadius:6}}>PRÓXIMO</span>}
                    </div>
                    <select value={ciudad} onChange={e=>{setCiudad(e.target.value);}}
                      style={{width:"100%",background:C.bg,border:`1.5px solid ${ciudad?C.accent:C.border}`,borderRadius:10,color:C.text,padding:"9px 10px",fontSize:13,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",fontWeight:600}}>
                      <option value="">Selecciona ciudad</option>
                      {ciudades.map(c=><option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                )}
              </div>
              {ciudad && ciudad!=="Los Mochis" && (
                <div style={{marginTop:10,background:"#FFF3E0",borderRadius:10,padding:"8px 12px",display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:16}}>🚧</span>
                  <span style={{color:"#E65100",fontSize:12,fontWeight:600}}>{ciudad} estará disponible próximamente.</span>
                </div>
              )}
            </div>

            <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
              <select value={sort} onChange={e=>setSort(e.target.value)} style={{background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:10,color:C.sub,padding:"8px 12px",fontSize:12,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>
                <option value="rating">Mejor calificados</option>
                <option value="jobs">Más trabajos</option>
              </select>
              <button onClick={()=>setAvail(!avail)} style={{background:avail?C.greenL:C.surface,border:`1.5px solid ${avail?C.green:C.border}`,borderRadius:10,color:avail?C.green:C.sub,padding:"8px 12px",fontSize:12,cursor:"pointer",fontWeight:700,fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>● Disponibles</button>
            </div>


            <div style={{color:C.muted,fontSize:12,marginBottom:12,fontWeight:500}}>
              {loadingDB && sourceWorkers.length===0 ? "Cargando trabajadores..." : `${filtered.length} maestro${filtered.length!==1?"s":""} encontrado${filtered.length!==1?"s":""}${loadingDB ? " · actualizando" : ""}`}
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {filtered.length===0 ? (
                <div style={{textAlign:"center",padding:"48px 0",color:C.muted}}>
                  <div style={{fontSize:48,marginBottom:12}}>{loadingDB ? "⏳" : "🔧"}</div>
                  <div style={{fontWeight:600,marginBottom:4}}>{loadingDB ? "Cargando directorio" : "Sin resultados"}</div>
                  <div style={{fontSize:13}}>{loadingDB ? "Manteniendo la sesión activa mientras llega Supabase." : "Prueba con otro oficio o ciudad"}</div>
                </div>
              ) : filtered.map((w,i)=>{
                const m = TM[w.trade]||{color:C.accent,icon:"🔧"};
                const esPremium = premiumIds.has(w.id);
                const posicion  = esPremium ? null : i - premiumTop.length + 1;

                return (
                  <div key={w.id} onClick={()=>{setSelected({type:"worker",data:w});setScreen("workerProfile");}}
                    style={{background:esPremium?"#FFFDE7":C.surface,
                      border:`1.5px solid ${esPremium?"#F9A825":C.border}`,
                      borderRadius:18,padding:"18px",cursor:"pointer",transition:"all 0.2s",
                      position:"relative",boxShadow:esPremium?"0 4px 20px #F9A82530":"0 2px 8px rgba(0,0,0,0.04)"}}
                    onMouseEnter={e=>{e.currentTarget.style.borderColor=esPremium?"#F9A825":m.color;e.currentTarget.style.boxShadow=esPremium?`0 6px 24px #F9A82540`:`0 6px 20px ${m.color}20`;e.currentTarget.style.transform="translateY(-1px)";}}
                    onMouseLeave={e=>{e.currentTarget.style.borderColor=esPremium?"#F9A825":C.border;e.currentTarget.style.boxShadow=esPremium?"0 4px 20px #F9A82530":"0 2px 8px rgba(0,0,0,0.04)";e.currentTarget.style.transform="translateY(0)";}}>

                    {/* Badge premium o posición */}
                    {esPremium ? (
                      <div style={{position:"absolute",top:14,right:14,background:"linear-gradient(135deg,#F9A825,#F57F17)",color:"#fff",borderRadius:10,padding:"4px 12px",fontSize:11,fontWeight:800,display:"flex",alignItems:"center",gap:4,boxShadow:"0 2px 8px #F9A82540"}}>
                        ★ Premium
                      </div>
                    ) : posicion<=3 ? (
                      <div style={{position:"absolute",top:14,right:14,background:["#FFF3CD","#F0F0F0","#FDE8DC"][posicion-1],color:["#C17F3B","#808080","#A0522D"][posicion-1],borderRadius:8,padding:"3px 10px",fontSize:10,fontWeight:800,border:`1px solid ${["#F5A62340","#C0C0C040","#CD7F3240"][posicion-1]}`}}>
                        #{posicion}
                      </div>
                    ) : null}

                    <div style={{display:"flex",gap:14,alignItems:"flex-start"}}>
                      <div style={{position:"relative",flexShrink:0}}>
                        <Av letters={w.avatar} color={m.color} size={52} dot={w.available}/>
                        {esPremium && <div style={{position:"absolute",bottom:-4,right:-4,background:"#F9A825",borderRadius:"50%",width:18,height:18,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,boxShadow:"0 1px 4px rgba(0,0,0,0.2)"}}>★</div>}
                      </div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
                          <span style={{fontFamily:"'Georgia',serif",fontSize:15,fontWeight:800,color:C.text}}>{w.name}</span>
                          {w.verified&&<span style={{color:C.accent,fontSize:11,fontWeight:700}}>✓</span>}
                        </div>
                        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:8}}>
                          <span style={{fontSize:12}}>{m.icon}</span>
                          <span style={{color:m.color,fontSize:12,fontWeight:700}}>{w.trade}</span>
                          <span style={{color:C.muted,fontSize:12}}>· {w.specialty}</span>
                        </div>
                        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10,flexWrap:"wrap"}}>
                          <Stars rating={w.rating}/>
                          <span style={{color:C.muted,fontSize:11}}>{w.reviews} reseñas</span>
                          <span style={{color:C.faint}}>·</span>
                          <span style={{color:C.muted,fontSize:11}}>{w.jobs} trabajos</span>
                          <span style={{color:C.faint}}>·</span>
                          <span style={{color:C.muted,fontSize:11}}>📍 {w.zone}</span>
                        </div>
                        <div style={{display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
                          {w.badges.map(b=><Chip key={b} text={b} color={m.color} small/>)}
                          {!w.available&&<Chip text="Ocupado" color={C.muted} small/>}

                        </div>
                      </div>
                    </div>

                    {/* Barra de score solo para premium */}
                    {esPremium && (
                      <div style={{marginTop:12,paddingTop:10,borderTop:`1px dashed #F9A82540`}}>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                          <span style={{color:"#854F0B",fontSize:10,fontWeight:700}}>★ Posición premium garantizada</span>
                          <span style={{color:"#854F0B",fontSize:10}}>Aparece primero en tu oficio</span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Sección Nuevos — solo cuando hay búsqueda activa */}
            {hayBusqueda && nuevos.length>0 && (
              <div style={{marginTop:24}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
                  <div style={{height:1,flex:1,background:C.border}}/>
                  <div style={{background:C.blueL,border:`1px solid ${C.blue}30`,borderRadius:20,padding:"4px 14px",display:"flex",alignItems:"center",gap:6}}>
                    <span style={{fontSize:12}}>🌱</span>
                    <span style={{color:C.blue,fontSize:11,fontWeight:700}}>Nuevos en Ficio</span>
                  </div>
                  <div style={{height:1,flex:1,background:C.border}}/>
                </div>
                <div style={{background:C.blueL,border:`1px solid ${C.blue}25`,borderRadius:12,padding:"10px 14px",marginBottom:12}}>
                  <span style={{color:C.sub,fontSize:12}}>Estos maestros acaban de unirse. Aún no tienen historial — dales la oportunidad de demostrar su trabajo.</span>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  {nuevos.map(w=>{
                    const m=TM[w.trade]||{color:C.accent,icon:"🔧"};
                    return (
                      <div key={w.id} onClick={()=>{setSelected({type:"worker",data:w});setScreen("workerProfile");}}
                        style={{background:C.surface,border:`1.5px solid ${C.blue}30`,borderRadius:18,padding:"16px",cursor:"pointer",transition:"all 0.2s",boxShadow:"0 2px 8px rgba(0,0,0,0.04)",opacity:0.9}}
                        onMouseEnter={e=>{e.currentTarget.style.borderColor=C.blue;e.currentTarget.style.opacity="1";}}
                        onMouseLeave={e=>{e.currentTarget.style.borderColor=`${C.blue}30`;e.currentTarget.style.opacity="0.9";}}>
                        <div style={{display:"flex",gap:12,alignItems:"center"}}>
                          <Av letters={w.avatar} color={m.color} size={44} dot={w.available}/>
                          <div style={{flex:1}}>
                            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
                              <span style={{fontFamily:"'Georgia',serif",fontSize:14,fontWeight:800,color:C.text}}>{w.name}</span>
                              <span style={{background:C.blueL,color:C.blue,fontSize:9,fontWeight:800,padding:"2px 7px",borderRadius:8}}>🌱 NUEVO</span>
                            </div>
                            <div style={{color:m.color,fontSize:12,fontWeight:600}}>{w.trade} · {w.specialty}</div>
                            <div style={{color:C.muted,fontSize:11,marginTop:2}}>📍 {w.zone} · {w.exp} años de experiencia</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {!hasTrabajador && (
              <div style={{background:`linear-gradient(135deg,${C.accentL},#FFF8F0)`,border:`1.5px solid ${C.accent}25`,borderRadius:18,padding:"22px 20px",textAlign:"center",marginTop:20}}>
                <div style={{fontSize:32,marginBottom:8}}>🔨</div>
                <div style={{fontFamily:"'Georgia',serif",fontWeight:800,color:C.text,fontSize:18,marginBottom:6}}>¿Eres maestro de oficio?</div>
                <div style={{color:C.sub,fontSize:13,marginBottom:14}}>Regístrate gratis · Accede al fondo de contingencia</div>
                <Btn full onClick={()=>setScreen("reg-worker")}>Registrarme gratis →</Btn>
              </div>
            )}
          </>
        )}

        {tab==="supervisors" && (
          <div>
            <div style={{background:C.blueL,border:`1.5px solid ${C.blue}30`,borderRadius:14,padding:"14px 16px",marginBottom:14}}>
              <div style={{color:C.blue,fontWeight:700,fontSize:13,marginBottom:4}}>🏗️ Supervisión Profesional</div>
              <div style={{color:C.sub,fontSize:13}}>Un ingeniero o arquitecto revisa el trabajo en sitio. <strong style={{color:C.text}}>$499 por visita.</strong></div>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {supervisorsDB.map(s=>(
                <div key={s.id} style={{background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:18,padding:"18px",boxShadow:"0 2px 8px rgba(0,0,0,0.04)"}}>
                  <div style={{display:"flex",gap:14,alignItems:"flex-start"}}>
                    <Av letters={s.avatar} color={s.color} size={52} dot={s.available}/>
                    <div style={{flex:1}}>
                      <div style={{fontFamily:"'Georgia',serif",fontSize:15,fontWeight:800,color:C.text,marginBottom:2}}>{s.name}</div>
                      <div style={{color:s.color,fontSize:12,fontWeight:600,marginBottom:8}}>{s.specialty}</div>
                      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}><Stars rating={s.rating}/><span style={{color:C.muted,fontSize:11}}>{s.reviews} supervisiones · {s.exp} años</span></div>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <Chip text="Cédula SEP ✓" color={C.blue}/>
                        <div style={{display:"flex",gap:8,alignItems:"center"}}>
                          <span style={{fontFamily:"'Georgia',serif",fontWeight:800,color:C.accent,fontSize:20}}>${s.price}</span>
                          <Btn small color={s.available?s.color:"#CCC"} onClick={()=>{if(s.available)setScreen("supervision-flow");}}>
                            {s.available?"Contratar":"Ocupado"}
                          </Btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA registro supervisor */}
            <div onClick={()=>setScreen("reg-supervisor")} style={{background:`linear-gradient(135deg,${C.blueL},#EEF4FC)`,border:`1.5px solid ${C.blue}25`,borderRadius:18,padding:"20px",textAlign:"center",marginTop:20,cursor:"pointer",transition:"all 0.2s"}}
              onMouseEnter={e=>e.currentTarget.style.boxShadow=`0 6px 20px ${C.blue}20`}
              onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
              <div style={{fontSize:32,marginBottom:8}}>🏗️</div>
              <div style={{fontFamily:"'Georgia',serif",fontWeight:800,color:C.text,fontSize:17,marginBottom:4}}>¿Eres Ing. o Arq.?</div>
              <div style={{color:C.sub,fontSize:13,marginBottom:6}}>Regístrate como supervisor y gana <strong style={{color:C.blue}}>$349 por cada visita</strong></div>
              <div style={{color:C.muted,fontSize:11,marginBottom:14}}>Sin cuota mensual · Tú manejas tu agenda · Cédula SEP requerida</div>
              <div style={{background:C.blue,color:"#fff",borderRadius:12,padding:"12px 20px",fontWeight:700,fontSize:14,display:"inline-block"}}>Registrarme como supervisor →</div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};
